import "../common/elements/Header.scss";
import translate from "@/i18n/translate";
import Header from "@/features/common/elements/Header";
import OrgProfileContent from "@/features/common/elements/OrgProfileContent";
import ScrollableHeader from "../common/elements/ScrollableHeader";
import { useContext, useEffect } from "react";
import { onScrollChangeBreadCrumb } from "../../static/js/commons";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";
import PreviewModal from "../lightcast/PreviewModal";
import UnauthorizedComponent from "@/features/insights/UnauthorizedComponent";
import { usePageTitle } from '@/hooks/usePageTitle';
import { useIntl } from 'react-intl';
export interface OrgProfileComponentProps {
  setSelectedTabView: (tabId: string) => void;
  auth: boolean;
}

export default function OrgProfileComponent({
  setSelectedTabView,
  auth
}: OrgProfileComponentProps): JSX.Element {
  const { institution } = useContext<AppContextInterface>(AppContext);
  const intl = useIntl();

  const pageTitle = institution?.name
    ? `${institution.name} - ${intl.formatMessage({ id: 'app.pageTitle.institutionProfile' })}`
    : intl.formatMessage({ id: 'app.pageTitle.institutionProfile' });

  usePageTitle(pageTitle);

  useEffect(() => {
    setTimeout(function () {
      onScrollChangeBreadCrumb();
    }, 1000);
  }, []);

  let displayName = institution && institution.name;
  return (
    <>
      {auth ? (
        <>
          <Header displayName={displayName} />

          <ScrollableHeader displayName={displayName} productView="navigator" />

          <div className="insights-hub-body flex-row">
            <div id="main-org-profile-container" className="main-org-profile">
              <div>
                <div className="page-banner -insights-header insights-header-home">
                  <h2 className="titles">Insights</h2>
                  <div className="description">
                    {translate("app.header.description")}
                  </div>
                </div>
                <div className="body -height" id="tab-components">
                  <OrgProfileContent
                    setSelectedTabView={setSelectedTabView}
                    productView="navigator"
                  />
                </div>
              </div>
            </div>
          </div>
          <PreviewModal></PreviewModal>
        </>
      ) : (
        <UnauthorizedComponent />
      )}
    </>
  );
}
